<template>
    <div class="page-bg login">
        <v-container fill-height justify-center>
            <div class="login-block">
                <div class="Client-logo">
                    <img :src="logo" class="Client-logo-img" />
                </div>
                <v-form class="login-frm">
                    <v-row>
                        <v-col cols="12" sm="12" class="pad-zero user-type">
                            <v-select
                                v-model="selectedCenterId"
                                @change="onCenterSelect"
                                :items="centers"
                                label="Select Center"
                                dense
                                hide-details
                                outlined
                                class="required"
                            ></v-select>
                            <InputError :data="error.center" />
                        </v-col>
                        <v-col cols="12" sm="12" class="pad-zero user-type">
                            <v-select
                                v-model="selectedBatch"
                                :items="batches"
                                label="Select Batch"
                                hide-details
                                dense
                                outlined
                                class="required"
                            ></v-select>
                            <InputError :data="error.batch" />
                        </v-col>
                        <v-col v-if="onlineUser" cols="12" sm="12" class="pad-zero user-type">
                            <v-select
                                v-model="selectedTargetExam"
                                :items="examList"
                                label="Select Target Exam"
                                hide-details
                                dense
                                outlined
                                class="required"
                            ></v-select>
                            <InputError :data="error.exam" />
                        </v-col>
                        <v-col v-if="onlineUser" cols="12" sm="12" class="pad-zero user-type">
                            <v-select
                                v-model="selectedClass"
                                :items="classes"
                                label="Select Target Year"
                                hide-details
                                dense
                                outlined
                                class="required"
                            ></v-select>
                            <InputError :data="error.class" />
                        </v-col>
                        <v-col v-if="onlineUser" cols="12" sm="12" class="pad-zero user-type">
                            <v-text-field
                                v-model="rollNumber"
                                label="Roll Number" 
                                type="number"
                                @keydown.space.prevent
                                @keypress="allowedOnlyNumber($event, true)"
                                min="1"
                                hide-details
                                dense
                                outlined
                                class=""
                            ></v-text-field>
                            <InputError :data="error.roll_number" />
                        </v-col>
                        <v-col cols="12" sm="12" class="pad-zero">
                            <div class="signup-primary sign-up-terms top-0">
                                <div class="user-new-signup">

                                    <div
                                        v-if="canShowParnetAddButton"
                                        @click="openParentDialog"
                                        class="plus-parent"
                                    >
                                        <v-icon>mdi-plus-circle</v-icon>
                                        <span class="add-par">Add Parent</span>
                                        <span class="optional-text">(optional)</span>
                                    </div>
																	<div class="user-terms-block" v-if="showPrivacyAndTerms">
                                        <div class="user-terms-check">
                                            <v-checkbox
                                                input-value=""
                                                value
                                                v-model="ischecked"
                                            ></v-checkbox>
                                        </div>
                                        <div class="user-terms-text-outer">
                                            <div class="user-terms-text">
                                                I accept the
                                                <a @click="termandcondition"
                                                    >Terms of Service</a
                                                >
                                                and
                                                <a @click="privacyPolicy"
                                                    >Privacy Policy</a
                                                >
                                            </div>
                                        </div>
                                        <InputError :data="error.ischecked" />
                                    </div>
                                </div>
                                <div class="sign-up-btn">
                                    <v-btn
                                        @click="onSubmit"
                                        class="right-btn cust-btn"
                                        color="primary"
                                    >Done</v-btn>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-form>
                <div v-if="isDefaultInstitute &&myInstitute &&  !myInstitute.is_white_labeled" class="power-logo">
                    <img src="../../../assets/img/logo-footer.png" class="master-logo" />
                </div>
            </div>
        </v-container>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";

export default {
    name: "SignupAddParent",
    data() {
        return {
            batches: [],
            classes: [],
            centers: [],
            selectedCenterId: null,
            selectedClass: null,
            selectedBatch: null	,
			ischecked:false,
            logo: this.getInstituteLogo(),
            error: {
                batch: {
                    type: null,
                    message: "Please select batch",
                },
                center: {
                    type: null,
                    message: "Please select center",
                },
                class: {
                    type: null,
                    message: "Please select target year",
                },
				ischecked: {
					type: null,
					message: "Please accept Terms & Conditions and Privacy Policy",
				},
                exam: {
                    type: null,
                    message: "Please select target exam",
                },
                roll_number: {
                    type: null,
                    message: "Roll number must be a maximum of 10 digits.",
                },
            },
			showPrivacyAndTerms:true,
            onlineUser: false,
            examList: constants.TARGET_EXAM.map((c) => c),
            selectedTargetExam: null,
        };
    },
    watch: {
        selectedCenterId(val) {
            this.error.center.type = null;
        },
        selectedClass(val) {
            this.error.class.type = null;
        },
        selectedBatch(val) {
            this.error.batch.type = null;
        },
		ischecked(){
			this.error.ischecked.type = null;
		},
        selectedTargetExam(val) {
            this.error.exam.type = null;
        },

        rollNumber() {
            this.error.roll_number.type = null;
        }
    },
    methods: {
        ...mapActions({
            getCenters: "centerAndBatchStore/getCenters",
            getBatches: "centerAndBatchStore/getBatches",
            getClasses: "userStore/getClasses",
            signUp: "userStore/signUp",
            setSignUpStudentData: "userStore/setSignUpStudentData",
        }),
        onCenterSelect(centerId) {
            this.batches = [];
            this.getBatches({ center_id: [centerId] })
                .then((response) => {
                    this.loading = false;
                    this.batches = response.list.map((x) => {
                        let c = {};
                        c.text = x.name;
                        c.value = x.id;
                        return c;
                    });
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        requestGetClasses() {
            this.getClasses()
                .then((response) => {
                    this.loading = false;
                    this.classes = response.map((x) => {
                        let c = {};
                        c.text = x.name;
                        c.value = x.class_code;
                        return c;
                    });
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        requestGetCenters() {
            this.getCenters()
                .then((response) => {
                    this.loading = false;
                    this.centers = response.map((x) => {
                        let c = {};
                        c.text = x.name;
                        c.value = x.id;
                        return c;
                    });
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        onSubmit() {
            if (this.validate()) {
                this.$root.showLoader = true;
                let centerName = this.centers.find((x) => x.value === this.selectedCenterId);
                this.signUp({
                    ...this.signUpData,
                    class: this.selectedClass ? this.selectedClass.toString() : centerName.text,
                    batch_id: this.selectedBatch,
                    target_exam: this.selectedTargetExam,
                    target_year: this.selectedClass.toString(),
                    roll_number: this.rollNumber
                })
                    .then((response) => {
                        this.$root.showLoader = false;
                        this.$toasted.success(`Success\n${response.message}`, {
                            icon: "check_circle", className:'new-class'
                        });
                        this.$router.push({ name: "login" }).catch(() => {});
                    })
                    .catch((err) => {
                        this.$root.showLoader = false;
                    });
            }
        },
        validate() {
            let isValid = true;
            this.error.center.type = null;
            this.error.batch.type = null;
            this.error.class.type = null;
				this.error.ischecked.type =null;

            if (!this.selectedCenterId) {
                this.error.center.type = "error";
                isValid = false;
            }
            if (!this.selectedBatch) {
                this.error.batch.type = "error";
                isValid = false;
            }
            if (!this.selectedClass && this.onlineUser) {
                this.error.class.type = "error";
                isValid = false;
            }
			if (!this.ischecked && this.showPrivacyAndTerms) {
				this.error.ischecked.type ='error';
				isValid = false
			}
            if (!this.selectedTargetExam && this.onlineUser) {
                this.error.class.type = "error";
                isValid = false;
            }

            if ((this.rollNumber) && this.rollNumber.length > 10) {
                this.error.roll_number.type = 'error';
                isValid = false;
            }
            return isValid;
        },
        openParentDialog() {
            this.setSignUpStudentData({
                class: this.selectedClass.toString(),
                batch_id: this.selectedBatch,
                center_id: this.selectedCenterId,
                target_exam: this.selectedTargetExam,
                target_year: this.selectedClass.toString(),
                roll_number:this.rollNumber
            });
            this.$router.push({ name: "student-signup-step3" });
        },
		termandcondition(){
		let routeData = this.$router.resolve({name: 'terms-and-conditions'});
		window.open(routeData.href, '_blank');
	},
	privacyPolicy(){
		let routeData = this.$router.resolve({name: 'privacy-policy'});
		window.open(routeData.href, '_blank');
	},
    },
    computed: {
        ...mapState("userStore", ["signUpData", "signUpStudentData", "isDefaultInstitute",'myInstitute']),
        canShowParnetAddButton() {
            return (
                this.selectedCenterId &&
                this.selectedBatch &&
                this.selectedClass && 
                this.selectedTargetExam
            );
        },
    },
    mounted() {
		 const instiute = JSON.parse(localStorage.getItem('myInstitute'));
        this.onlineUser = instiute.id === constants.ONLINE_INSTITUTE_ID ? false : true;
	  this.showPrivacyAndTerms = !constants.CUSTOM_DOMAIN_ID.includes(instiute.id)
        if (this.signUpData) {
            this.requestGetCenters();
            this.requestGetClasses();

            if (this.signUpStudentData) {
                if (this.signUpStudentData.center_id) {
                    this.onCenterSelect(this.signUpStudentData.center_id);
                }
                this.selectedClass = this.signUpStudentData.class;
                this.selectedBatch = this.signUpStudentData.batch_id;
                this.selectedCenterId = this.signUpStudentData.center_id;
                this.selectedTargetExam = this.signUpStudentData.target_exam;
            }
        } else {
            this.$router.push({ name: "signup" });
        }
    },
};
</script>
